import Cookies from "universal-cookie";
import Paging from "../modules/Components/Paging";
import errortrans from "../translate/error";
import { useEffect } from "react";
import { useState } from "react";
import env from "../env";
import tabletrans from "../translate/tables";
import CommentsTable from "../modules/Comments/CommentsTable";
import { updateUrlWithFilters } from "../../src/utils/filterUtils";
const cookies = new Cookies();

function Comments(props) {
  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;
  const [content, setContent] = useState("");
  const [filters, setFilters] = useState("");
  const [loading, setLoading] = useState(0);
  const token = cookies.get(env.cookieName);
  useEffect(() => {
    setLoading(1);
    const body = {
      offset: filters.offset ? filters.offset : "0",
      pageSize: filters.pageSize ? filters.pageSize : "10",
      // customer: filters.customer,
      // orderNo: filters.orderNo,
      // status: filters.status,
      // brand: filters.brand,
      // dateFrom: filters.date && filters.date.dateFrom,
      // dateTo: filters.date && filters.date.dateTo,
      // access: "manager",
    };
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify(body),
    };
    console.log(postOptions);
    fetch(env.siteApi + "/panel/document/list-comment", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(0);
          setContent("");
          setTimeout(() => setContent(result.filter), 200);
        },
        (error) => {
          setLoading(0);
          console.log(error);
        },
      );
  }, [filters]);
  return (
    <div className="user" style={{ direction: direction }}>
      <div className="od-header" style={{ flexDirection: "row" }}>
        <div className="od-header-info">
          <div className="od-header-name">
            <p>کامنت ها</p>
          </div>
        </div>
      </div>
      <div className="list-container">
        <div className="user-list">
          {loading ? (
            env.loader
          ) : (
            <CommentsTable content={content} lang={lang} />
          )}
        </div>
        <Paging
          content={content}
          setFilters={setFilters}
          filters={filters}
          lang={props.lang}
          updateUrlWithFilters={updateUrlWithFilters}
        />
      </div>
    </div>
  );
}
export default Comments;
